export const langTabInfos = {
  fr: {
    sessionDuration: 'Durée session',
    maxSpeed: 'Vitesse max',
    distance: 'Distance parcourue',
    ltl: '    ',
  },
  eng: {
    sessionDuration: 'Session duration',
    maxSpeed: 'Max speed',
    distance: 'Covered distance',
    ltl: '    ',
  },
}
